import React from "react";

const Loading = () => {
    return (
        <div>
            <i className="loading" />
        </div>
    );
};

export default Loading;